import ES6Promise from "es6-promise";
import Router from "vue-router";
import Vue from "vue";
import UserService from "./services/user-service";
import Login from "@/components/Login";
import store from "./store";
import Reporting from "@/components/reporting";
import UserManual from "@/components/userManual";
import Settings from "@/components/Settings";
import contentSettingsMain from "@/components/contentSettingsMain";
import Main from "@/components/Main";
import Application from "@/components/Application";
import apiService from "./services/api-service";

const ID = 40;

ES6Promise.polyfill();

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      name: "Login",
      component: Login,
    },
    {
      path: "/main",
      name: "Main",
      component: Main,
      children: [
        {
          path: "application/:id",
          name: "Application",
          component: Application,
          meta: {
            authRequired: true,
          },
        },
      ],
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/reporting",
      name: "Reporting",
      component: Reporting,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/userManual",
      name: "UserManual",
      component: UserManual,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/contentSettingsMain",
      name: "contentSettingsMain",
      component: contentSettingsMain,
      meta: {
        authRequired: true,
      },
    },
    {
      path: "/settings",
      name: "Settings",
      component: Settings,
      meta: {
        authRequired: true,
      },
    },
  ],
});

let initialLoad = true;

router.beforeEach((to, from, next) => {
  let verified = UserService.isVerified();
  let authRequired = Boolean(to.meta.authRequired);
  let authPromise = null;

  if (initialLoad) {
    router.app.$nextTick(() => {
      router.app.$loader.startLoading("Main");
      router.app.$loader.startLoading("Map");
    });
  }
  if (verified) {
    if (!authRequired) {
      initialLoad = false;
      return next("/main");
    }

    if (authRequired) {
      initialLoad = false;
      return next();
    }
  }
  if (!to.name) {
    initialLoad = false;
    return next("/");
  }
  authPromise = new Promise((resolve) => {
    resolve(null);
  });
  if (initialLoad) {
    authPromise = apiService.verify();
  }
  authPromise
    .then((response) => {
      if (response && response.data) {
        verified = response.data.isAuthenticated;
        UserService.setVerified(verified);
      }
      if (verified) {
        if (response.data.tenantId === ID) {
          initialLoad = false;
          UserService.setVerified(true);
          UserService.setUser(response.data.user);
          store.commit("setUser", response.data.user);
          store.commit("setAccountId", response.data.tenantId);
          return next("/main");
        } else {
          UserService.setVerified(false);
          return next("/login");
        }
      } else {
        if (!verified) {
          if (authRequired) {
            initialLoad = false;
            return next("/login");
          }

          if (!authRequired) {
            initialLoad = false;
            return next();
          }
        }
      }
    })
    .catch(() => {
      return next("/login");
    });
});

export default router;
